/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourcesDetails {
    getFixupPrototypeFunction() { return ResourcesDetails.fixupPrototype; }

    static newInstance(model: Partial<ResourcesDetails>): ResourcesDetails {
        let obj = Object.assign(new ResourcesDetails(), model);
        ResourcesDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourcesDetails>): ResourcesDetails {
        if (!model) return null;
        return ResourcesDetails.newInstance(<ResourcesDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourcesDetails) {
        if (!obj) return;

        models.ResourcesDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourcesDetails): boolean {
        Object.setPrototypeOf(obj, ResourcesDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Mapping of input parameter for this template to the output parameter of any of the previous templates
     */
    param_mapper: any;

    /**
     * Can be “on_demand” or “scheduled”. Indicates whether this template/script will be executed immediately on executing the blueprint or will be scheduled for one/more occurrences
     */
    execution_type: string;

    /**
     * A short name that represents the action performed by the template. Useful while viewing the job output while executing the blueprint
     */
    action: string;

    /**
     * Resource Name
     */
    name: string;

    /**
     * Resource ID
     */
    id: string;

}
